import { createMuiTheme } from "@material-ui/core";
import { COLORS } from "../../utils/js/constants";

export default function sellProductStyle(theme) {
	return {
		containerSell: {
			padding: theme.spacing(4),
			display: 'flex',
			overflow: 'auto',
			flexDirection: 'column',
			background: COLORS.grey,
		},
		title: {
			color: COLORS.lightYellow,
			display: 'flex',
			alignItems: 'center'
		},
		titleChild: {
			color: COLORS.white,
			display: 'flex',
			alignItems: 'center',
			fontWeight: 'bold'
		},
		listItem: {
			color: COLORS.white,
			display: "flex",
			alignItems: "center",
			width: '50%'
		},
		productDetails: {
			marginTop: 10,
			marginBottom: 10,
		},
		card: {
			display: 'flex',
			background: COLORS.grey,
			boxShadow: 0
		},
		cover: {
			minHeight: 110,
			minWidth: 110,
			width: 500,
			borderRadius: '5px'
		},
		productList: {
			display: 'flex',
			flexWrap: 'wrap',
		},
		inputVendas: {
			color: COLORS.white,
			opacity: 0.5
		},
		containerButton: {
			display: 'flex',
			justifyContent: 'flex-end',
		},
		sellButton: {
			background: COLORS.green2,
			color: 'white',
			fontWeight: 'bold',
			borderRadius: '20px',
			marginLeft: 20
        },
		textSpace: {
			padding: '5px',
			width: "10%"
		}
	}
}

export const theme = createMuiTheme({
	overrides: {
		MuiListItemText: {
			secondary: {
				color: "white",
				opacity: 0.5,
				marginLeft: "5px",
			},
		},
		MuiPaper: {
			elevation1: {
				boxShadow: "0px 0px 0px 0px",
			},
		},
		MuiButton: {
			containedPrimary: {
				backgroundColor: "green",
				fontWeight: 700,
				"&:hover": {
					backgroundColor: COLORS.green,
				},
				marginLeft: "40px",
			},
		},
		MakeStyles: {
			title: {
				flexGrow: 0,
			},
		},
		MuiInput: {
			underline: {
				"&:after": {
					borderBottom: "2px solid #FADD05",
				},
			},
			marginLeft: "40px",
		},
		MuiFormControl: {
			root: {
				width: "50px",
			},
		},
		MuiInputBase: {
			input: {
				color: "rgba(255,255,255, 0.5)",
				"&:focus": {
					color: "rgb(255,255,255)",
				},
			},
		},
	},
});
